import { render, staticRenderFns } from "./RepairRegistrationReportList.vue?vue&type=template&id=0cc6a1fd&scoped=true"
import script from "./RepairRegistrationReportList.vue?vue&type=script&lang=js"
export * from "./RepairRegistrationReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc6a1fd",
  null
  
)

export default component.exports